import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, inject } from '@angular/core'
import { EChartsOption } from 'echarts/types/dist/shared'
import { BackEndService } from 'src/app/services/backend.service'
import { NgxEchartsDirective, provideEchartsCore } from 'ngx-echarts'
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent, VisualMapComponent } from 'echarts/components'
import { LineChart, BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import * as echarts from 'echarts/core'
import { CurrencyPipe, DatePipe } from '@angular/common'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import dayjs from 'dayjs'

echarts.use([TitleComponent, TooltipComponent, GridComponent, LineChart, CanvasRenderer, LegendComponent, VisualMapComponent, BarChart])

@Component({
  selector: 'app-equity-pricing-graph',
  templateUrl: './equity-pricing-graph.component.html',
  styleUrls: ['./equity-pricing-graph.component.scss'],
  imports: [
    NgxEchartsDirective,
    CurrencyPipe,
    DatePipe,
    NgxBootstrapIconsModule
  ],
  providers: [
    provideEchartsCore({ echarts }),
  ]
})

export class EquityPricingGraphComponent implements OnChanges {
  private searchService = inject(BackEndService)
  private _change = inject(ChangeDetectorRef)

  @Input() id = 0
  @Input() timespan = '6m'
  @Input() showEquityData = false
  public chartData: EChartsOption = {}
  public equity: any = {}
  public delta = ''
  public iconNames = IconNamesEnum

  ngOnChanges(): void {
    if (this.id > 0) {
      this.searchService.search({
        area: 'data/instruments/equity-pricing-data/' + this.id,
        timespan: this.timespan,
      }, false).subscribe((result: any) => {
        if (result.data && result.data.length > 0) {

          this.equity = result.equity

          const dateList = result.data.map((item: any) => item.pricedate)
          const valueList = result.data.map((item: any) => parseFloat(item.price))
          const volumeList = result.data.map((item: any) => parseFloat(item.volume))

          const [previousDay, today] = valueList.slice(-2)

          if (previousDay < today) {
            this.delta = 'increase'
          } else if (previousDay > today) {
            this.delta = 'decrease'
          }

          this.chartData = {
            // Make gradient line here
            visualMap: [
              {
                show: false,
                type: 'continuous',
                seriesIndex: 0,
                min: 0,
                max: 400
              },
            ],
            title: [
              {
                left: 'center',
                text: 'Recent Equity Pricing'
              },
            ],
            tooltip: {
              trigger: 'axis',
              formatter: (params: any) => {
                return `<table><tr><td colspan="3">${dayjs(params[0].name).format('MMM DD, YYYY')}</td></tr>
              <tr><td>${params[0].marker}</td><td>Price:</td><td class="text-end fw-bold">${params[0].value}</td></tr>
              <tr><td>${params[1].marker}</td><td>Volume:</td><td class="text-end fw-bold">${params[1].value}</td></tr></table>`
              }
            },

            xAxis: [
              {
                data: dateList,
                axisLabel: {
                  formatter: (params: string) => dayjs(params).format('MMM DD, YYYY')
                }
              },
            ],
            yAxis: [
              {
                type: 'value',
                name: 'Price',
                position: 'left',
              },
              {
                type: 'value',
                name: 'Volume',
                position: 'right',
              },
            ],
            series: [
              {
                type: 'line',
                name: 'Price',
                showSymbol: false,
                data: valueList
              },
              {
                name: 'Volume',
                type: 'bar',
                data: volumeList,
                yAxisIndex: 1,
              },
            ],
          }
          this._change.markForCheck()
        }
      })
    }

  }
}